import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Select from 'components/forms/Select';
import { resultsToOptions } from 'utils/misc';
import { getEmailConfigs } from 'redux/actions/emailConfigActions';
import { debounce } from 'lodash';


const EmailServiceProviderFilter = ({ value, onChange, ...props }) => {
  const handleLoadOptions = async (filterString) => {
    await props.getEmailConfigs({ search: filterString, campaign_ids: props.campaignIds });
  };

  useEffect(() => {
    // eslint-disable-next-line func-names
    (async function () {
      await handleLoadOptions();
    }());
  }, []);

  const options = resultsToOptions(props.emailConfigs.results, 'email') || [];

  return (
    <Select
      isMulti
      placeholder="Email"
      value={value}
      onChange={onChange}
      cacheOptions
      defaultOptions
      options={options}
      onInputChange={debounce(input => handleLoadOptions(input), 500)}
    />
  );
};

EmailServiceProviderFilter.propTypes = {
  value: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  emailConfigs: PropTypes.shape({
    results: PropTypes.shape({}.isRequired),
  }).isRequired,
  getEmailConfigs: PropTypes.func.isRequired,
  campaignIds: PropTypes.arrayOf(PropTypes.number),
};

EmailServiceProviderFilter.defaultProps = {
  campaignIds: null,
};

export default compose(connect(
  state => ({
    emailConfigs: state.accountEmailConfigs,
    user: state.user,
  }),
  { getEmailConfigs },
))(EmailServiceProviderFilter);
